import { useLocalSearchParams } from 'expo-router';
import React from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import TripExtension from '@/components/trip-extension';

export default function TripExtensionScreen() {
  const { styles } = useStyles(stylesheet);
  const { id } = useLocalSearchParams();

  return (
    <View style={styles.container}>
      <TripExtension id={id} />
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    flex: 1,
    backgroundColor: theme.colors.background_1,
  },
}));
